module.exports = __webpack_public_path__ + "static/media/iPhone15Max.546295fa.png";